import { MerchandisingService } from './merchandising.service';

export default angular
  .module('sfMobile.services.merchandising', [
    'sfMobile.constants.merchandising',
  ])
  .factory('merchandisingService', MerchandisingService).name;
